<template>
  <div>
    <!-- <img src='../assets/img/doubleClass/banner.png' alt=''> -->
    <Header></Header>
    <div class="banner">
      <img src="https://img.stem.cn/online/join/doubleClass/01.jpg" class="banner_img">
      <img src="https://img.stem.cn/online/join/doubleClass/phone1.jpg" class="phone1" @click="nextFooter">
      <img src="https://img.stem.cn/online/join/doubleClass/goin.jpg" class="goin" @click="nextFooter">
    </div>
    <div class="double_class">
      <div v-for="(item,index) in imgList" :key="index"> 
        <img :src="item">
      </div>
    </div>
    <div class="form_content">
      <div class="header">
        现 在 就 成 为 鲨 鱼 公 园 双 师 课 堂 合 作 伙 伴
      </div>
      <div class="phone">
        400-080-6869
      </div>
      <div class="form_box">
       <input type="text" v-model="form.city" placeholder="咨询区域城市" class="intut_box">
       <input type="text" v-model="form.name" placeholder="姓名" class="intut_box">
       <input type="text" v-model="form.phone" placeholder="联系方式" class="intut_box">
       <input type="text" v-model="form.budget" placeholder="投资预算" class="intut_box">
       <img src="https://img.stem.cn/online/join/doubleClass/icon_01.jpg" class="icon_01">
       <img src="https://img.stem.cn/online/join/doubleClass/icon_02.jpg" class="icon_02">
       <img src="https://img.stem.cn/online/join/doubleClass/icon_03.jpg" class="icon_03">
       <img src="https://img.stem.cn/online/join/doubleClass/icon_04.jpg" class="icon_04">
       <div class="submit" @click="submitFun">
         立即提交
       </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import axios from 'axios'

export default {
  name: 'DoubleClass',
  components: {Header, Footer},
  data () {
    return {
      msg: 'DoubleClass',
      form:{
        city:'',
        name:'',
        phone:'',
        budget:'',
      },
      imgList:[
        'https://img.stem.cn/online/join/doubleClass/1.png',
        'https://img.stem.cn/online/join/doubleClass/2.png',
        'https://img.stem.cn/online/join/doubleClass/3.png',
        'https://img.stem.cn/online/join/doubleClass/4.png',
        'https://img.stem.cn/online/join/doubleClass/5.png',
        'https://img.stem.cn/online/join/doubleClass/6.png',
        'https://img.stem.cn/online/join/doubleClass/7.png',
        'https://img.stem.cn/online/join/doubleClass/8.png',
        'https://img.stem.cn/online/join/doubleClass/9.png',
        'https://img.stem.cn/online/join/doubleClass/10.png',
        'https://img.stem.cn/online/join/doubleClass/11.png',
        'https://img.stem.cn/online/join/doubleClass/12.png',
        'https://img.stem.cn/online/join/doubleClass/13.png',
        'https://img.stem.cn/online/join/doubleClass/14.png',
      ]
    }
  },
  methods:{
      nextFooter(){
        setTimeout(function () {
          scrollTo(0, document.body.offsetHeight)
         })
      },
      submitFun(){
         if(!/(^1[3|4|5|7|8][0-9]{9}$)/.test(this.form.phone)){
            this.$notify.error({
              title: '提醒',
              message: '手机格式不正确 , 请再次填写手机号'
            });
          // this.$message.error('手机格式不正确 , 请再次填写手机号');
          return;
         }
         let _this = this;
          var url = 'https://ol.stem.cn:1443/jm/doubleTeacher/consultation.php'
          axios.post(url,_this.form).then(function (response) {
             _this.$message({
              message: '提交成功',
              type: 'success'
            });
            _this.form = {
              city:'',
              name:'',
              phone:'',
              budget:'',
            }
          }).catch(function (error) {
            _this.$message.error('提交失败,请再次提交');
            
          })
      }
    
    
  }
}
</script>
<style lang="scss" scoped>
   @function vw($px) {
    @return ($px / 750) * 100vw
  };
  .banner {
    width: 100%;
    height: 550px;
    background-color: #00024c;
    position:relative;
    .banner_img {
      margin: 0 auto;
      width: 1200px;
      display:block;
    }
    .phone1 {
      position: fixed;
      display:block;
      top:330px;
      right:0px;
      width: 287px;
      cursor: pointer;
    }
    .goin {
      position: fixed;
      display:block;
      top:440px;
      right:0px;
      width: 101px;
      cursor: pointer;
    }
  }
  .double_class {
    width: 100%;
    // height: 9248px;
    background-color:#072056;
    // background:url('../assets/img/doubleClass/banner.jpg') no-repeat;
    // background-size:100% 100%;
    div {
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        width: 1200px;
      }
    }
    
  }
  .form_content {
      height: 673px;
      width: 100%;
      background-color:#0f172e;
      padding-top: 40px;
      box-sizing: border-box;
      .header {
        height: 81px;
        line-height: 81px;
        color: #f6e032;
        font-weight: 600;
        font-size: 37px;
        width: 807px;
        margin: 0 auto;
        border-bottom:6px solid  #f6e032;
      }
      .phone {
        color: #f6e032;
        font-weight: 600;
        font-size: 37px;
        text-align:center;
        margin-top: 20px;
      }
      .form_box {
         width: 700px;
         margin: 0 auto;
         padding-top:20px;
         box-sizing: border-box;
         position:relative;
         .intut_box {
          width: 100%;
          height: 78px;
          border-radius:40px;
          line-height: 78px;
          margin-bottom: 10px;
          padding-left:80px;
          font-size: 22px;
          outline:medium;
          outline:none ;
         box-sizing: border-box;

         }
         .submit {
          width: 300px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          font-size: 22px;
          margin: 0 auto;
          background-color:#fae033;
          color: black;
          border-radius:30px;
          margin-top: 12px;
          cursor: pointer;
          &:hover {
            font-size:40px;
            cursor: pointer;

          }
         }
         .icon_01 {
          width: 51px;
          position:absolute;
          top:36px;
          left:21px;
         }
         .icon_02 {
          width: 51px;
          position:absolute;
          top:125px;
          left:21px;
         }
         .icon_03 {
          width: 51px;
          position:absolute;
          top:213px;
          left:21px;
         }
         .icon_04 {
          width: 51px;
          position:absolute;
          top:302px;
          left:21px;
         }
      }
    }
</style>
